<script setup lang="ts">
import { faArrowLeft, faSpinner } from '@fortawesome/pro-regular-svg-icons';
import { NuxtLink } from '#components';

const layoutStore = useLayoutStore();
const { autoReserveInProcessCount } = classToRefs(layoutStore);
onMounted(() => layoutStore.getAutoReserveInProcessCount());
</script>
<template>
    <NuxtLink
        v-show="autoReserveInProcessCount"
        to="/panel/auto-reserve"
        class="auto-reserve-root"
    >
        <mr-icon :icon="faSpinner" color="var(--blue-500)" pulse />
        <mr-typography weight="500" color="var(--blue-500)" grow>
            {{ autoReserveInProcessCount }} سفر در حال رهگیری برای رزرو خودکار
        </mr-typography>
        <mr-icon :icon="faArrowLeft" color="var(--blue-500)" />
    </NuxtLink>
</template>

<style lang="scss" scoped>
.auto-reserve-root {
    display: flex;
    gap: 8px;
    align-items: center;
    background-color: usePalette($p-blue, $p-100);
    padding: 12px 16px;
}
</style>
